import { Annotation } from "@/components/annotation";
import { useZoneHistoryQuery } from "@/shared/api";
import { useViewSettings } from "@/view-settings";
import { useSchedules } from "@/virtual-store/hooks/useSchedules";
import { useSelector } from "@legendapp/state/react";
import { Plane } from "@react-three/drei";
import { Vector3 } from "three";

export function ZonesInner() {
  const viewSettings = useViewSettings();
  const { activeSchedule } = useSchedules({ queryKey: "zoneHistorySchedules" });
  const showLabels = useSelector(() => viewSettings.showPlanogramLabels.get());

  const { data: zoneHistory } = useZoneHistoryQuery(
    {
      historyId: activeSchedule?.id!,
    },
    {
      skip: !activeSchedule,
    }
  );

  return (
    <>
      {zoneHistory?.results.map((zone) => {
        const position = new Vector3()
          .addVectors(
            new Vector3(zone.zone_min_x, 0.05, -zone.zone_min_y),
            new Vector3(zone.zone_max_x, 0.05, -zone.zone_max_y)
          )
          .divideScalar(2);

        return (
          <group key={zone.id}>
            {showLabels && (
              <Annotation
                wrapperClassName="pointer-events-auto"
                position={position}
                zIndexRange={[100, 0]}
              >
                <span className="text-xs whitespace-nowrap font-bold">
                  {zone.description}
                </span>
              </Annotation>
            )}
            <Plane
              key={zone.id}
              args={[
                zone.zone_max_x - zone.zone_min_x,
                zone.zone_max_y - zone.zone_min_y,
              ]}
              position={position}
              rotation={[-Math.PI / 2, 0, 0]}
              material-color="limegreen"
              material-transparent={true}
              material-opacity={0.4}
            />
          </group>
        );
      })}
    </>
  );
}

export function Zones() {
  const viewSettings = useViewSettings();
  const isVisible = useSelector(() => viewSettings.showZones.get());

  if (!isVisible) return null;

  return <ZonesInner />;
}
